module.exports = __webpack_public_path__ + "img/1-Icon-Employed.ebb86261.png";